var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5725 0.486328H5.42749C2.43 0.486328 0 2.91633 0 5.91382V55.0587C0 58.0563 2.43 60.4863 5.42749 60.4863H54.5724C57.57 60.4863 60 58.0563 60 55.0587V5.91382C60 2.91633 57.57 0.486328 54.5725 0.486328ZM18.5665 52.2943C18.5665 53.1666 17.8594 53.8738 16.9871 53.8738H10.2636C9.39126 53.8738 8.68414 53.1666 8.68414 52.2943V24.1098C8.68414 23.2375 9.39126 22.5304 10.2636 22.5304H16.9871C17.8594 22.5304 18.5665 23.2375 18.5665 24.1098V52.2943ZM13.6253 19.8736C10.0977 19.8736 7.23801 17.0138 7.23801 13.4862C7.23801 9.95863 10.0977 7.09889 13.6253 7.09889C17.1529 7.09889 20.0127 9.95863 20.0127 13.4862C20.0127 17.0138 17.1531 19.8736 13.6253 19.8736ZM53.7031 52.4215C53.7031 53.2235 53.0529 53.8738 52.2509 53.8738H45.0361C44.2341 53.8738 43.5839 53.2235 43.5839 52.4215V39.2014C43.5839 37.2293 44.1624 30.5594 38.43 30.5594C33.9836 30.5594 33.0817 35.1247 32.9006 37.1735V52.4215C32.9006 53.2235 32.2505 53.8738 31.4483 53.8738H24.4704C23.6684 53.8738 23.0182 53.2235 23.0182 52.4215V23.9826C23.0182 23.1806 23.6684 22.5304 24.4704 22.5304H31.4483C32.2503 22.5304 32.9006 23.1806 32.9006 23.9826V26.4415C34.5493 23.9672 36.9996 22.0574 42.2166 22.0574C53.7693 22.0574 53.7031 32.8505 53.7031 38.7808V52.4215Z",
    fill: "#0077B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.486328)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1654ce703f7e8c7f8df11f50554175e0.svg";
export { ForwardRef as ReactComponent };